import React from 'react';
import styled from 'styled-components';
import DiscountBadge from '../DiscountBadge';
import { Tooltip } from '@mui/material';

const CardDiv = styled.div`
	border: 1px solid #e5e0e0;
	border-radius: 11px;
	width: 100%;
	cursor: pointer;

	& > .ff-ecom-card-image {
		display: flex;
		align-items: center;
		display: inline-block;
		position: relative;
		width: 100%;
		z-index: 1;
		&::before {
			content: '';
			position: absolute;
			background-color: #fbfbfb;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 2;
			mix-blend-mode: darken;
			border-radius: 11px;
		}

		&:hover {
			&::before {
				z-index: -1;
			}
			& > div > img {
				opacity: 0;
				& + .hidden {
					opacity: 1 !important;
				}
			}
		}
		& > div {
			width: 100%;
			aspect-ratio: 0.7;
			position: relative;

			& > svg {
				position: absolute;
				right: 16px;
			}
			& > img {
				width: 100%;
				height: 100%;
				object-fit: inherit;
				border-radius: 11px;
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
				position: absolute;
				left: auto;
				top: auto;
				backface-visibility: hidden;
				&.hidden {
					opacity: 0;
				}
			}
		}
		&.imageNotAvailable {
			justify-content: center;
			background-color: #f5f5f5;
			border: 1px solid rgba(0, 0, 0, 0.1);
			& > div.placeholder-text {
				color: #898989;
				text-align: center;
				font-family: var(--fontFamily);
				font-size: 12px;
				font-style: normal;
				font-weight: 400;
				line-height: 18px;
				letter-spacing: 0.4px;
				padding: 0 8px;
			}
		}
	}
	& > .ff-ecom-card-details {
		padding: 0px 12px;
		padding-bottom: 6px;
		font-family: var(--fontFamily) !important;
		font-size: 14px;
		& > .ecom-title,
		& > .ecom-header,
		& > .ecom-price {
			max-width: 238px;
			margin-bottom: 4px;
			display: flex;
			margin-top: 0px;
			&.ecom-title {
				// min-height: 45px;
				margin-top: 7px;
				font-weight: 600;
				width: fit-content;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
				margin-right: 24px;
				font-size: 16px;
				font-weight: 500;
			}
			& > span:first-child {
				float: left;
				font-size: 15px;
				margin-top: 4px;
				margin-right: 4px;
			}
			& > span:nth-child(2) {
				font-size: 20px;
				font-weight: 600;
			}
			& > span:last-child {
				float: right;
				font-size: 20px;
				margin-top: 4px;
				margin-left: 4px;
			}
			&.ecom-price {
				color: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
			}
		}
	}
`;
type Props = {
	title: string;
	header: string;
	price: string;
	mediaType: string;
	mediaLink: string;
	currency: string;
	selectedProduct: boolean;
	imageOnHover: string;
	showDiscount: boolean;
	colorMode: string;
	sale_price: string;
};
const EcomCard = ({
	title,
	header,
	price,
	mediaType,
	mediaLink,
	currency,
	selectedProduct,
	imageOnHover,
	showDiscount,
	colorMode,
	sale_price,
}: Props) => {
	return (
		<CardDiv
			colorMode={colorMode}
			imageOnHover={imageOnHover}
			className={`ff-ecom-cards ${selectedProduct ? 'selected' : ''}`}
		>
			<div
				className={`ff-ecom-card-image ${mediaLink.length ? 'imageNotAvailable' : ''
					}`}
			>
				{mediaType === 'image' && (
					<div>
						<>
							{mediaLink.length ? (
								<>
									<img src={mediaLink} alt='' />
									{imageOnHover && imageOnHover.length > 0 && (
										<img
											className='hidden'
											src={imageOnHover}
											alt=''
											image-on-hover={imageOnHover}
										/>
									)}
								</>
							) : (
								<div className='placeholder-text'>IMAGE NOT AVAILABLE</div>
							)}
						</>

						{showDiscount ? (
							<DiscountBadge
								colorMode={colorMode}
								percent={Number(
									((Number(price) - Number(sale_price)) / Number(price)) * 100
								)}
							/>
						) : null}
					</div>
				)}
				{mediaType === 'video' && <iframe src={mediaLink} title={mediaLink} />}
			</div>
			<div className='ff-ecom-card-details'>
				<Tooltip title={title}>
					<p className='ecom-title'>{title}</p>
				</Tooltip>
				<p className='ecom-header'>{header}</p>
				{price.length && parseInt(price) > 0 && (
					<div className='ecom-price'>
						<span>{currency}</span>
						<span>{price}</span>
						{/* <span>
							{price && price.indexOf('.') > -1 ? price.split('.')[1] : null}
						</span> */}
					</div>
				)}
			</div>
		</CardDiv>
	);
};

export default EcomCard;
